// extracted by mini-css-extract-plugin
export default {"loader":"globeLoader_loader__zZGBq"};